export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/opt/buildhome/repo/layouts/empty.vue").then(m => m.default || m)
}